import {ResourcesLoader} from '@fantasmagames/core/src/loader/ResourcesLoader';
import {View} from '@fantasmagames/slot/src/common/view/View';
import {Position} from '@fantasmagames/slot/src/modules/reels/ReelConstants';
import {WinNumbers} from '@fantasmagames/slot/src/modules/winpresentation/WinNumbers';

export class FreeSpinsInfoView extends View {
	protected _bgBox: PIXI.Sprite;

	protected _playedFreeSpins: PIXI.Text;
	protected _remainingFreeSpins: PIXI.Text;
	protected _multiplierFreeSpins: PIXI.Text;

	protected _remainingFreeSpinsBox: FreeSpinInfoBox;
	protected _multiplierFreeSpinsBox: FreeSpinInfoBox;

	protected _leftFreeSpinsValue: number;
	protected _totalFreeSpinsValue: number;

	protected _allTextsStyle: PIXI.TextStyle;

	protected _hasMiltiplier: boolean = false;

	public init(): void {
		super.init();

		this.initInfoBoxes();
	}

	public addOneFreeSpin(): void {
		this._totalFreeSpinsValue++;
		this.setRemainingFreeSpins(this._totalFreeSpinsValue, this._leftFreeSpinsValue);
	}

	public addPlayedSpin(): void {
		this._leftFreeSpinsValue++;
		this.setRemainingFreeSpins(this._totalFreeSpinsValue, this._leftFreeSpinsValue);
	}

	public setRemainingFreeSpins(totalFS: number, remaining: number): void {
		try {
			this._leftFreeSpinsValue = remaining;
			this._totalFreeSpinsValue = totalFS;
			this._remainingFreeSpinsBox.updateValueWithString(`${remaining.toString(10)}/${totalFS.toString(10)}`);
		} catch (e) {

		}
	}

	public set multiplierFreeSpins(multiplierValue: number) {
		if (this._hasMiltiplier) {
			this._multiplierFreeSpinsBox.updateValue(multiplierValue);
		}
	}

	protected initInfoBoxes(): void {
		this._bgBox = new PIXI.Sprite(this.resources.getSpritesheetTexture('HUD.json', 'FREESPIN_BACKGROUND.png'));
		const bgPos: Position = this.layout.getAbsolutePosition('FREESPIN_MENU');
		this.container.addChild(this._bgBox);
		this._bgBox.position.set(bgPos.x, bgPos.y);
		this._bgBox.anchor.set(0.5);

		this._remainingFreeSpinsBox = this.setupInfoBox(
			'TEXT_REMAINING.png',
			'FREESPIN_REMAINING',
			'FREESPIN_FREESPINS_REMAINING',
			'FREESPIN_REMAINING_TEXT',
			'BOX_FREE_SPINS.png',
		);

		if (this._hasMiltiplier) {
			this._multiplierFreeSpinsBox = this.setupInfoBox(
				'TEXT_MULTIPLIER.png',
				'FREESPIN_MULTIPLIER',
				'FREESPIN_MULTIPLIER_NUMBER',
				'FREESPIN_MULTIPLIER_TEXT',
				'BOX_MULTIPLIER.png',
			);
		}
	}

	protected setupTextField(textField: PIXI.Text, layoutName: string): void {
		const pos: Position = this.layout.getAbsolutePosition(layoutName);
		textField.position.set(pos.x, pos.y);
		textField.anchor.set(0.5);
		this.container.addChild(textField);
	}

	protected setupInfoBox(
		title: string,
		layoutName: string,
		numberLayoutName: string,
		textLayoutName: string,
		hudObjectName: string,
	): FreeSpinInfoBox {
		const pos: Position = this.layout.getAbsolutePosition(layoutName);
		// Get the local position in relation to their parent bone (layoutName)
		const textPos: Position = this.layout.getPosition(textLayoutName);
		const numberPos: Position = this.layout.getPosition(numberLayoutName);

		const box: FreeSpinInfoBox = new FreeSpinInfoBox(this.resources, 0, title, hudObjectName);
		box.setTextPosition(textPos);
		box.setNumberPosition(numberPos);
		box.position.set(pos.x, pos.y);
		this.container.addChild(box);

		return box;
	}
}

export class FreeSpinInfoBox extends PIXI.Sprite {
	protected _resources: ResourcesLoader;

	protected _bg: PIXI.Sprite;

	protected _title: PIXI.Sprite;

	protected _titleText: string;

	protected _value: number;
	protected _valueText: WinNumbers;
	protected _kerning: number;
	protected _maxWidth: number;

	protected _hudObjectName: string;

	constructor(resources: ResourcesLoader, value: number, title: string, hudObjectName: string, kerning?: number, maxWidth?: number) {
		super();

		this._resources = resources;
		this._value = value;
		this._titleText = title;
		this._hudObjectName = hudObjectName;
		this._kerning = kerning;
		this._maxWidth = maxWidth;

		this.setupObject(title);
	}

	public updateValue(value: number): void {
		this._value = value;
		this._valueText.showNumber(value.toString(10));
	}

	public checkIfMaxWidthNotExceeded(): void {
		if (this._maxWidth !== undefined && this._valueText.getLocalBounds().width > this._maxWidth) {
			const scale = this._maxWidth / this._valueText.getLocalBounds().width;
			this._valueText.scale.set(scale);
		}
	}

	public updateValueWithString(value: string): void {
		this._valueText.showNumber(value);
		this.checkIfMaxWidthNotExceeded();
	}

	public setNumberPosition(numberPos: Position): void {
		this._valueText.position.set(numberPos.x, numberPos.y);
	}

	public setTextPosition(textPos: Position): void {
		this._title.position.set(textPos.x, textPos.y);
	}

	private setupObject(titleImageName: string): void {
		this._bg = new PIXI.Sprite(this._resources.getSpritesheetTexture('HUD.json', this._hudObjectName));
		this._bg.anchor.set(0.5);

		this._title = new PIXI.Sprite(this._resources.getLocaleTextImage(titleImageName));
		this._title.anchor.set(0.5);

		this._valueText = new WinNumbers(this._resources, 'SMALL_');
		this._valueText.numberAnchor.y = 0.5;

		if (this._kerning) {
			this._valueText.numberKerning = this._kerning;
		}

		this.addChild(this._bg);
		this.addChild(this._title);
		this.addChild(this._valueText);
	}

	public get currentValue(): number {
		return this._value;
	}

	public get title(): string {
		return this._titleText;
	}

	public get valueText(): WinNumbers {
		return this._valueText;
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/freespins/info/FreeSpinsInfoView.ts